interface MixAndMatchComponent {
  bundleConfig: {
    id?: string
    options?: any[] | string
    categories?: any[] | string
    addOnProducts?: any[]
  }
  options?: any[]
  categories?: any[]
  init(): void
  formatPrice(price: number): string
  updateSelectedCategoryOnScroll(): void
  updateHeaderOffset(): void
  getNextTierQuantity(): number
  getNextTierDiscount(): number
  getCurrentDiscount(): number
  getTotalCompareAtPrice(): number
  getProductPrice(product: any): number
  getProductCompareAtPrice(product: any): number
  addProduct(product: any, variantId: string, image: string, category: string, message?: string | null): void
  removeProduct(productId: string): void
  recalculateProductPrices(): void
  updateProductQuantity(productId: string, quantity: number): void
  shouldShowPrices(): boolean
  getTotalPrice(): number
  getTotalQuantity(type?: string): number
  createBundleLineItemProperties(): any[]
  checkIfPrimaryAddToCartButtonIsVisible(): boolean
  checkLimitQuantity(): boolean
  checkIfProductsAddToCartButtonIsVisible(): boolean
  refreshCurrentOption(): void
  refreshCurrentDate(): void
  addToCart(): void
  resetMixAndMatch(): void
  meetsQuantityRequirement(requiredQuantity: number): boolean
  getTotalQuantityWithAllCategories(): number
  roundPrice(price: number): number
  openModal(product: any): void
  closeModal(): void
  getExcludedCategories(): string[]
  selectedCategory: number
  selectedProducts: any[]
  currentDate: number
  currentOption: any
  nextOption: any
  numberOfProducts: number
  nextTierQuantity: number
  numberOfProductsToNextTier: number
  nextTierDiscount: number
  totalPrice: number
  totalCompareAtPrice: number
  identifier: string
  isModalOpen: boolean
  isLoading: boolean
  selectedModalProduct: any
  loadingStates: Record<string, boolean>
  showDepliant?: boolean
  
  notifications: Array<{ id: number; message: string }>
  showNotification(message: string): void
  closeNotification(notificationId: number): void
}

export default {
  name: 'mixAndMatch',
  component(): MixAndMatchComponent {
    return {
      updateSelectedCategoryOnScroll() {
        this.selectedCategory = 1
      },
      bundleConfig: window.orsay?.bundleConfig || {
        options: [],
        categories: [],
        addOnProducts: []
      },
      options: [],
      categories: [],
      selectedCategory: 1,
      selectedProducts: [],
      currentDate: Date.now(),
      currentOption: {},
      nextOption: {},
      numberOfProducts: 0,
      nextTierQuantity: 0,
      numberOfProductsToNextTier: 0,
      nextTierDiscount: 0,
      totalPrice: 0,
      totalCompareAtPrice: 0,
      identifier: '',
      isModalOpen: false,
      selectedModalProduct: null,
      notifications: [],
      isLoading: false,
      loadingStates: {},
      showNotification(message) {
        const id = Date.now()
        this.notifications = [{ id, message }];
          
        //Supprimer automatiquement après 5 secondes avec la fonction closeNotification
        setTimeout(() => {
          this.closeNotification(id)
        }, 5000)
      },

      closeNotification(notificationId: number) {
        this.notifications = this.notifications.filter(n => n.id !== notificationId);
      },
      
      init() {
        if (!window.orsay || !window.orsay.bundleConfig) {
          return
        }

        // Set up categories
        if (
          window.orsay.bundleConfig.categories &&
          Array.isArray(window.orsay.bundleConfig.categories) &&
          window.orsay.bundleConfig.categories.length > 0
        ) {
          this.categories = window.orsay.bundleConfig.categories
          this.selectedCategory = 1 // Start with first category
        }

        // Set up options
        if (window.orsay.bundleConfig.options) {
          this.options = window.orsay.bundleConfig.options
          this.nextOption = this.options[1] || this.options[0]
          this.currentOption = this.options[0]
        }

        // Only call these methods if we have valid options
        if (this.options && this.options.length > 0) {
          this.getNextTierQuantity()
          this.getNextTierDiscount()
        }

        // Initialize with empty selected products
       
        this.selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
       

        this.identifier = `${this.bundleConfig.id}`
     

        this.$nextTick(() => {
          this.updateHeaderOffset()
          window.addEventListener('resize', () => this.updateHeaderOffset())
        })

        this.recalculateProductPrices()
      },

      getNextTierQuantity() {
        this.refreshCurrentOption()
        if (this.nextOption && this.nextOption.quantity !== undefined) {
          this.nextTierQuantity = this.nextOption.quantity
          this.numberOfProductsToNextTier = this.nextTierQuantity - this.getTotalQuantity('product')

          if (this.numberOfProductsToNextTier < 0) {
            this.numberOfProductsToNextTier = 0
          }
        } else {
          this.nextTierQuantity = 0
          this.numberOfProductsToNextTier = 0
        }
        return this.numberOfProductsToNextTier
      },

      getNextTierDiscount() {
        if (this.nextOption && this.nextOption.price && this.nextOption.price.value !== undefined) {
          this.nextTierDiscount =  this.nextOption.price.value + '%'
        } else {
          this.nextTierDiscount = '0%'
        }
        return this.nextTierDiscount
      },

      getTotalQuantity(type = null) {

        const excludedCategories = this.getExcludedCategories();

        this.numberOfProducts = this.selectedProducts
          .filter(product => {
            // Filtre par type si spécifié
            const typeMatch = type ? product.type === type : product.type !== 'addOns'
            
            const normalizedProductCategory = (product.category || '').toLowerCase().trim()
            const categoryMatch = !excludedCategories.includes(normalizedProductCategory)
      
            return typeMatch && categoryMatch
          })
          .reduce((total, product) => total + (product.quantity || 1), 0)
        
        return this.numberOfProducts
      },

      getExcludedCategories() {
        // Catégories toujours exclues (hardcodées) - normalisées en lowercase
        const alwaysExcluded = ['trousses', 'estuche'];
        
        // Catégories où addMultiple est false - normalisées en lowercase
        const categoriesWithAddMultipleFalse = (this.categories || [])
          .filter(category => category.addMultiple === false)
          .map(category => category.title.toLowerCase().trim())
        
        
        return [...alwaysExcluded, ...categoriesWithAddMultipleFalse]
      },

      getTotalQuantityWithAllCategories() {
        return this.selectedProducts.reduce((total, product) => total + (product.quantity || 1), 0)
      },

      createBundleLineItemProperties() {
        const items = this.selectedProducts.map(product => ({
          variantId: product.variantId,
          quantity: product.quantity,
          price: this.getProductPrice(product),
          type: product.type,
          ...(product.type === 'product' ? { category: product.category } : { properties: product.properties })
        }))

        if (this.bundleConfig.showDepliant) {
          const depliantVariantId = this.bundleConfig?.productDepliant?.variants?.[0]?.id?.toString()
          const manualItem = {
            variantId: depliantVariantId,
            quantity: 1,
            price: 0,
            type: 'product',
            category: 'Dépliant'
          }
          
          return items.concat(manualItem)
        }

        return items
      },

      checkIfPrimaryAddToCartButtonIsVisible() {
        this.refreshCurrentOption()
        const totalQuantity = this.getTotalQuantity('product')
        const totalQuantityAddOns = this.getTotalQuantity('addOns')

        if (this.currentOption && this.currentOption.quantity <= totalQuantity) return true

        if (!this.nextOption || !this.nextOption.add_on) return false

        const {
          quantity: quantityMin,
          add_on: {minimum: quantityMinAddOn}
        } = this.nextOption

        return totalQuantity >= quantityMin && totalQuantityAddOns >= quantityMinAddOn
      },

      checkLimitQuantity() {
        if (!this.nextOption || !this.nextOption.add_on) return false

        const totalQuantity = this.getTotalQuantity('product')
        const totalQuantityAddOns = this.getTotalQuantity('addOns')
        const quantityMin = this.nextOption.quantity
        const quantityMinAddOn = this.nextOption.add_on.minimum

        if (totalQuantity < quantityMin) {
          return false
        }
        if (totalQuantityAddOns < quantityMinAddOn) {
          return false
        }
        return true
      },

      checkIfProductsAddToCartButtonIsVisible() {
        this.refreshCurrentOption()
        const totalQuantity = this.getTotalQuantity('product')

        if (this.currentOption && this.currentOption.quantity <= totalQuantity) {
          return true
        }

        return false
      },

      refreshCurrentOption() {
        if (!this.options || !Array.isArray(this.options) || this.options.length === 0) return

        this.nextOption = this.options.find(option => option.quantity > this.getTotalQuantity('product'))
        if (!this.nextOption) {
          this.nextOption = this.options[this.options.length - 1]
        }

        const totalQuantity = this.getTotalQuantity('product')

        this.currentOption = this.options.filter(option => option.quantity <= totalQuantity).sort((a, b) => b.quantity - a.quantity)[0]

        if (!this.currentOption) {
          this.currentOption = this.options[0]
        }
      },

      refreshCurrentDate() {
        this.currentDate = Date.now()
      },

      async addToCart() {
        this.refreshCurrentOption();
        const totalPrice = this.getTotalPrice();
        const timestamp = Date.now();
        this.identifier=`${this.bundleConfig.id}-${timestamp}`;

        const productProperties = {};
        this.selectedProducts.forEach((product) => {
          productProperties[product.title] = `x${product.quantity}`;
        });
    
  
        const cartData = {
          items: [{
            id: this.currentOption.variant_id + "",
            quantity: 1,
            properties: {
              "_dynamic_add_on_bundle_id": this.identifier,
              "_dynamic_add_on_bundle_items": JSON.stringify(
                this.createBundleLineItemProperties()
              ),
            }
          }]
        };
            
         await window.liquidAjaxCart.add(cartData);
      
          this.selectedProducts = []
          localStorage.setItem('selectedProducts', JSON.stringify(this.selectedProducts));
        /*
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: this.currentOption.variant_id,
                quantity: 1,
                properties: {
                  ...productProperties,
                  "__orsay:original_bundle_price": totalPrice,
                  "__orsay:dynamic_add_on_bundle_id": this.identifier,
                  "__orsay:dynamic_add_on_bundle_items": JSON.stringify(
                    this.createBundleLineItemProperties()
                  ),
                },
              },
              
            ],
          }),
        });
        const data = await response.json();
        */
        this.resetMixAndMatch();
      },

      resetMixAndMatch() {
        this.selectedProducts = []
        this.totalPrice = '0€'
        this.totalCompareAtPrice = '0€'
        this.numberOfProducts = 0
        this.numberOfProductsToNextTier = 0
        this.nextTierDiscount = '0%'
        this.recalculateProductPrices()
        this.getTotalQuantity()
        this.getNextTierQuantity()
        this.getNextTierDiscount()
      },

      openModal(product) {
        this.selectedModalProduct = product;
        this.isModalOpen = true;
        document.body.style.overflow = 'hidden';
      },

      closeModal() {
        this.isModalOpen = false;
        this.selectedModalProduct = null;
        document.body.style.overflow = '';
      },

      meetsQuantityRequirement(requiredQuantity) {
        const totalQuantity = this.getTotalQuantity('product')
        return totalQuantity >= requiredQuantity
      },

      roundPrice(price) {
        return Math.round(price * 100) / 100
      },

      formatPrice(price) {
        return `${price}€`
      },

      getCurrentDiscount() {
        this.refreshCurrentOption()
        let discount = 0

        let totalQuantity = this.getTotalQuantity('product')
        if (
          this.currentOption &&
          this.currentOption.quantity !== undefined &&
          this.currentOption.price &&
          this.currentOption.price.value !== undefined
        ) {
          // if (totalQuantity >= this.currentOption.quantity) {
            discount = this.currentOption.price.value
          // }
        }
        return discount
      },

      getTotalPrice() {
        return this.roundPrice(this.selectedProducts.reduce((total, product) => total + this.getProductPrice(product) * product.quantity, 0))
      },

      getTotalCompareAtPrice() {
        return this.roundPrice(this.selectedProducts.reduce((total, product) => total + this.getProductCompareAtPrice(product), 0))
      },

      getProductPrice(product) {
        const basePrice = product.price / 100
        const discount = this.getCurrentDiscount() / 100
        const finalPrice = basePrice * (1 - discount) 
        return this.roundPrice(finalPrice)
      },

      getProductCompareAtPrice(product) {
        // supporte soit un objet produit (avec variants), soit une variante directe
        const currentVariant = Array.isArray(product?.variants)
          ? (product.variants.find(v => v.id === product.variantId) || product.variants[0])
          : product

        const basePrice = currentVariant.compare_at_price || currentVariant.price
        const priceInEuros = basePrice / 100
        return this.roundPrice(priceInEuros * product.quantity)
      },

      async addProduct(product, variantId, image, category, message) {

        const restrictedCategories = this.getExcludedCategories();
        const normalizedCategory = category?.toLowerCase().trim()

        if (normalizedCategory && restrictedCategories.includes(normalizedCategory)
          && this.selectedProducts.some(p => {
            const normalizedProductCategory = (p.category || '').toLowerCase().trim()
            return restrictedCategories.includes(normalizedProductCategory)
          })) {
          this.showNotification(message);
          return;
        }
        // Démarrer le loading pour ce bouton spécifique
        this.loadingStates[variantId] = true;
        try {

          // Simulation d'un délai avec setTimeout 
          await new Promise(resolve => setTimeout(resolve, 200));
          
         

          if (this.selectedProducts.find(p => p.id === product.id)) {
            this.updateProductQuantity(product.id, 1);
            return;
          }

          this.selectedProducts.push({
            ...product,
            variantId: variantId,
            image: image,
            quantity: 1,
            category: category,
            type: 'product'
          });
         
          
          localStorage.setItem('selectedProducts', JSON.stringify(this.selectedProducts));
          this.recalculateProductPrices();
          this.getTotalQuantity();
          this.getNextTierQuantity();
          this.getNextTierDiscount();
          
        } catch (error) {
          console.error('Erreur lors de l\'ajout du produit:', error);
          // Optionnel: afficher une notification d'erreur
          this.showNotification('Erreur lors de l\'ajout du produit');
        } finally {
          // Arrêter le loading pour ce bouton spécifique
          this.loadingStates[variantId] = false;
        }
      },

      removeProduct(productId) {
        this.selectedProducts = this.selectedProducts.filter(p => p.id !== productId)
        localStorage.setItem('selectedProducts', JSON.stringify(this.selectedProducts));
      },

      recalculateProductPrices() {
        this.selectedProducts = this.selectedProducts.map(product => ({
          ...product,
          price_with_discount: this.formatPrice(this.getProductPrice(product)),
          compared_price_with_discount: this.formatPrice(this.getProductCompareAtPrice(product))
        }))

        this.totalPrice = this.formatPrice(this.getTotalPrice())
        this.totalCompareAtPrice = this.formatPrice(this.getTotalCompareAtPrice())
      },

      updateProductQuantity(productId, quantity,message = null) {

       
        // find product in selectedProducts
        let currentProduct = this.selectedProducts.find(p => p.id === productId)
        if (!currentProduct) {
          return
        }

        const restrictedCategories = this.getExcludedCategories();
        const normalizedCategory = currentProduct.category?.toLowerCase().trim()
        
        const newQuantity = currentProduct.quantity + quantity

 
        if (newQuantity <= 0) {
          this.removeProduct(productId)

          localStorage.setItem('selectedProducts', JSON.stringify(this.selectedProducts));
        } else if (normalizedCategory && restrictedCategories.includes(normalizedCategory)) {
          this.showNotification(message);
          return;
        } else {
          currentProduct.quantity = newQuantity

          localStorage.setItem('selectedProducts', JSON.stringify(this.selectedProducts));
        }
        this.recalculateProductPrices()
        this.getTotalQuantity()
        this.getNextTierQuantity()
        this.getNextTierDiscount()
      },

      shouldShowPrices() {
        return this.totalPrice !== '0€' && this.selectedProducts.length > 0
      },

      updateHeaderOffset() {
        const header = document.querySelector('.header-wrapper') || document.querySelector('header')
        if (header) {
          const headerHeight = (header as HTMLElement).offsetHeight
          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`)
        }
      }
    }
  }
}
